import { SortableHandle } from 'react-sortable-hoc'
import { DragIndicator } from '@styled-icons/material/DragIndicator'

export const DragHandle = SortableHandle(() => <DragIndicator className={`cursor-move text-gray-500 w-8`} />)